export default __webpack_public_path__ + "static/media/HospitalLoginIllustration.a3cbeabb.svg";